import React from 'react';
import '../styles/WhyChooseUs.css';

function WhyChooseUs() {
  const reasons = [
    'Affordable & customizable packages',
    'Premium-grade materials',
    'Skilled engineering & construction teams',
    'Transparent process with regular updates',
    'Strict quality & safety standards',
    "Customizable Designs",
  ];

  return (
    <section className="why-choose-us">
      <div className="why-container">
        <h2 className="section-title">Why Choose Us?</h2>
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="checkmark-item">
              {reason}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;